/* eslint-disable no-console */

// CRA automatically replaces process.env.NODE_ENV at build time
 
const isProd = process.env.NODE_ENV === 'production';

const log = {
  log: (...args) => {
    if (!isProd) {console.log(...args);}
  },
  warn: (...args) => {
    if (!isProd) {console.warn(...args);}
  },
  error: (...args) => {
    if (!isProd) {console.error(...args);}
  },
};

export default log;
